import axios from 'axios';
import authHeader from './auth-header';
import Auth from "./auth.service";

import GlobalData from '../tools/GlobalData';

const API_URL = GlobalData.back_end_server_ip + ':' + GlobalData.back_end_server_port + '/api/user/';
//const API_URL = `http://1-58.69.222.102:3030/api/user/`;

function console_log( ...args){
	GlobalData.Console_log( ...args);
}
function console_log_err( ...args){
	GlobalData.Console_log_err( ...args);
}

const getPublicContent=()=>{
    return axios.get(`${API_URL}all`);
}
const getUserBoard=()=>{
    return axios.get(`${API_URL}user`, {headers: authHeader()});
}
const getModeratorBoard=()=>{
    return axios.get(`${API_URL}mod`, {headers:authHeader()});
}
const getAdminBoard=()=>{
    return axios.get(`${API_URL}admin`, {headers:authHeader()});
}

// TOKENS ------------------------------
const addTokens = (ss) => {
    const currentUser = Auth.getCurrentUser();
    return axios.get(`${API_URL}add_tokens?user_id=${currentUser.user_id}&user_key=${currentUser.access_key}`);
}
const addTokenCode=(token_code)=>{
    const currentUser = Auth.getCurrentUser();
    return axios.get(`${API_URL}add_token_code?user_id=${currentUser.user_id}&user_key=${currentUser.access_key}&token_code=${token_code}`);
}
const getPrepaidTokens = () => {
    const currentUser = Auth.getCurrentUser();
    return axios.get(`${API_URL}get_prepaid_tokens?user_id=${currentUser.user_id}&user_key=${currentUser.access_key}`);
}
const addPrepaidToken = (newTokenCount) => {
    const currentUser = Auth.getCurrentUser();
    return axios.post(`${API_URL}add_prepaid_token?user_id=${currentUser.user_id}&user_key=${currentUser.access_key}&token_count=${newTokenCount}`);
}
const deletePrepaidToken = (id) => {
    const currentUser = Auth.getCurrentUser();
    return axios.post(`${API_URL}delete_prepaid_token?user_id=${currentUser.user_id}&user_key=${currentUser.access_key}&id=${id}`);
}

//ANALYTICS
const postUserAnalyticsEvent = ( user_browser_id, geo_key, device_key, from, tip, info ) => {
	console_log( "user.service postUserAnalyticsEvent AXIOS", user_browser_id, from, tip, info);
		//!!! Undefined.length = , geo_key.length, device_key.length);
    return axios.post(`${API_URL
    	}post_user_analytics_event?geo_key=${geo_key
    	}&device_key=${device_key
    	}&user_browser_id=${user_browser_id
    	}&from=${from
    	}&tip=${tip
    	}&info=${info
    	}`);
}

const getUserAnalyticsId = ( geo_key, device_key ) => {
	console_log( "user.service getUserAnalyticsId AXIOS", geo_key.length, device_key.length);
    return axios.post(`${API_URL
    	}get_user_analytics_id?geo_key=${geo_key
    	}&device_key=${device_key
    	}`);
}

/*
	const getUserAnalyticsId = ( long_key) => {
		return axios.post(`${API_URL}get_user_analytics_id?long_key=${long_key}`);
	}
	method: "POST",
	headers: {
		Accept: "application/json",
		"Content-Type": "application/json",
		Authorization: `Bearer ${token}`
	},
	body: JSON.stringify({ order: createOrderData })
*/


export default {
    getPublicContent,
    getUserBoard,
    getModeratorBoard,
    getAdminBoard,
    addTokens,
    addTokenCode,
    getPrepaidTokens,
    addPrepaidToken,
    deletePrepaidToken,
    getUserAnalyticsId,
    postUserAnalyticsEvent,
};
